<script>
  import ClickOut from '../../../../utils/directives/clickout'
  export default{
    name: 'btn-relatorios',
    props: ['leilao'],
    data () {
      return {
        open: false
      }
    },
    computed: {
    },
    mounted () {},
    destroyed () {
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      }
    },
    directives: {ClickOut},
    components: {}
  }
</script>

<template>
  <div class="btn-group dropdown" :class="{ open: open}"  v-click-out="hide">
    <button class="btn btn-sm" data-toggle="dropdown" tabindex="1" aria-expanded="false" @click.stop.prevent="toggle"><i class="fa fa-print m-r-xs"></i> Relatórios <span class="caret"></span></button>
    <ul class="dropdown-menu no-padder">
      <li>
        <router-link :to="{name: 'leiloes.relatorios.lances', params: {id: leilao.id}}" tabindex="2"><i class="fa fa-usd fa-fw"></i> Lances</router-link>
      </li>
      <li>
        <router-link :to="{name: 'leiloes.relatorios.saida', params: {id: leilao.id}}" tabindex="2"><i class="fa fa-user fa-fw"></i> Saídas</router-link>
      </li>
      <li>
        <router-link :to="{name: 'leiloes.relatorios.lances.comitente', params: {id: leilao.id}}" tabindex="2"><i class="fa fa-usd fa-fw"></i> Lances por Comitente</router-link>
      </li>
      <li>
        <router-link :to="{name: 'leiloes.relatorios.resumo', params: {id: leilao.id}}" tabindex="2"><i class="fa fa-book fa-fw"></i> Resumo</router-link>
      </li>
    </ul>
  </div>
</template>



// WEBPACK FOOTER //
// BtnRelatorios.vue?60ba2d4f